import EnhancedTable from './EnhancedTable';
export default EnhancedTable;
